import {
  Link,
  Text,
} from '@chakra-ui/react';
import {
  useRestrictedBridges,
} from '@src/modules/performance/context/reports-api-hooks';
import Chart from 'react-apexcharts';
import GroupedRegionMessage from '@src/modules/performance/components/GroupedRegionMessage';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Restricted Bridges',
  content: [
    {
      title: 'No. of restricted bridges',
      description:
  <Text fontSize="inherit" mb={2}>
    The number of bridges on the selected road network with a weight or speed restriction. Some of those with a weight restriction may also have a speed restriction.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools" isExternal>NZTA Data and Tools, physical statistics - bridges</Link>
  </Text>,
    },
  ],
};

function RoadNetworkUseRestrictedBridges() {
  const { data: restrictedBridgesData, isLoading: isLoadingRestrictedBridges } = useRestrictedBridges();
  const isLoading = isLoadingRestrictedBridges;

  // Prepare data for the restricted bridges chart
  const restrictedBridgesYears = [...new Set(restrictedBridgesData?.map((item) => item.Year))];
  const restrictedBridgesChartData = [
    {
      name: 'Speed',
      type: 'line',
      data: restrictedBridgesData?.map((item) => ({
        x: item.Year,
        y: item.SpeedOnlyCount,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Weight',
      type: 'line',
      data: restrictedBridgesData?.map((item) => ({
        x: item.Year,
        y: item.WeightCount,
      })),
      color: CHART_COLOURS.orangered,
    },
  ];

  return (
    <ReportSection
      title="Restricted Bridges"
      isLoading={isLoading || !restrictedBridgesData}
      informationSource={informationSource}
      lockYear={restrictedBridgesData?.[0]?.LockYear}
    >
      <Chart
        options={{
          title: {
            text: 'No. of restricted bridges',
          },
          chart: {
            animations: {
              enabled: false,
            },
          },
          xaxis: {
            categories: restrictedBridgesYears,
            labels: {
              offsetY: 5,
              rotate: -45,
              rotateAlways: true,
            },
          },
          yaxis: [
            {
              forceNiceScale: false,
              labels: {
                formatter(y) {
                  return `${y.toFixed(0)}`;
                },
              },
            },
          ],
          grid: {
            padding: {
              left: 20,
            },
          },
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: (val) => `${val.toFixed(0)}`,
            },
          },
        }}
        series={restrictedBridgesChartData}
        type="line"
        width="100%"
        height="280"
      />
      <GroupedRegionMessage rcaIds={[1014, 1015, 1016]} />
    </ReportSection>
  );
}

export default RoadNetworkUseRestrictedBridges;
